import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ThemeProvider } from '@/components/ThemeProvider'
import { QueryProvider } from '@/providers/QueryProvider'
import { AgentConfigProvider } from '@/providers/AgentConfigProvider'
import { ClerkProvider } from '@clerk/clerk-react'
import { OrganizationInitializer } from '@/components/OrganizationInitializer'
import config from '@/config'

// Check if Clerk publishable key is available
if (!config.CLERK_PUBLISHABLE_KEY) {
  console.warn('Clerk publishable key not found. Authentication will be disabled.')
}

// Fix for mobile viewport height issues
function setMobileViewportHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// Set initial viewport height
setMobileViewportHeight();

// Update on resize (handles mobile browser UI changes)
window.addEventListener('resize', setMobileViewportHeight);
window.addEventListener('orientationchange', () => {
  setTimeout(setMobileViewportHeight, 100);
});

const AppContent = () => (
  <QueryProvider>
    <AgentConfigProvider>
      <ThemeProvider defaultTheme="light" storageKey="wrnt-ai-agent-theme">
        <OrganizationInitializer>
          <App />
        </OrganizationInitializer>
      </ThemeProvider>
    </AgentConfigProvider>
  </QueryProvider>
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {config.CLERK_PUBLISHABLE_KEY ? (
      <ClerkProvider
        publishableKey={config.CLERK_PUBLISHABLE_KEY}
        appearance={{
          baseTheme: undefined, // Will use system theme
          variables: {
            colorPrimary: 'hsl(var(--primary))',
            colorBackground: 'hsl(var(--background))',
            colorInputBackground: 'hsl(var(--background))',
            colorInputText: 'hsl(var(--foreground))',
          }
        }}
      >
        <AppContent />
      </ClerkProvider>
    ) : (
      <AppContent />
    )}
  </StrictMode>,
)
